import { Converter } from 'opencc-js'

// 初始化繁簡轉換器
const converter = Converter({ from: 'cn', to: 'twp' }) // 從簡體轉換為繁體（台灣正體）

/**
 * 將簡體中文文本轉換為繁體中文
 * @param {string} text 需要轉換的文本
 * @returns {string} 轉換後的文本
 */
export function convertToTraditional(text) {
  if (typeof text !== 'string' || !text) {
    return text
  }
  
  return converter(text)
}

/**
 * 處理 API 返回的對象，轉換指定字段的文本為繁體中文
 * @param {Object} obj 需要處理的對象
 * @param {Array} fields 需要轉換的字段列表
 * @returns {Object} 處理後的對象
 */
export function convertObjectFields(obj, fields = ['title', 'description', 'name', 'text', 'model_number']) {
  if (!obj || typeof obj !== 'object') {
    return obj
  }
  
  const result = { ...obj }
  
  // 處理直接字段
  fields.forEach(field => {
    if (result[field] && typeof result[field] === 'string') {
      result[field] = convertToTraditional(result[field])
    }
  })
  
  // 處理嵌套對象
  Object.keys(result).forEach(key => {
    // 處理嵌套對象
    if (result[key] && typeof result[key] === 'object' && !Array.isArray(result[key])) {
      result[key] = convertObjectFields(result[key], fields)
    }
    
    // 處理數組中的對象
    if (Array.isArray(result[key])) {
      result[key] = result[key].map(item => {
        if (item && typeof item === 'object') {
          return convertObjectFields(item, fields)
        }
        return item
      })
    }
  })
  
  return result
}

/**
 * 處理 API 返回的數組，轉換數組中每個對象的指定字段為繁體中文
 * @param {Array} array 需要處理的數組
 * @param {Array} fields 需要轉換的字段列表
 * @returns {Array} 處理後的數組
 */
export function convertArrayItems(array, fields = ['title', 'description', 'name', 'text', 'model_number']) {
  if (!Array.isArray(array)) {
    return array
  }
  
  return array.map(item => {
    if (typeof item === 'object' && item !== null) {
      return convertObjectFields(item, fields)
    }
    return item
  })
} 